import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CardContainerModule } from '@go-modules/components/card-container/card-container.module';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { MatMenuModule } from '@angular/material/menu';
import { MenuModule } from '@go-modules/components/menus/menu/menu.module';
import { NgxArchiveCardComponent } from './archive-card.component';
import { ThumbnailModule } from '@go-modules/components/thumbnail/thumbnail.module';
import { ArchiveMenuModule } from '@go-modules/components/archive/archive-menu/archive-menu.module';
import { EllipsisWithCountModule } from '@go-modules/components/ellipsis-with-count/ellipsis-with-count.module';
import { FormatDateModule } from '@go-modules/pipes/format-date/format-date.module';
import { DetectTextTruncationDirective } from '@go-modules/directives/truncate/detect-text-truncation.directive';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		CardContainerModule,
		GoMaterialModule,
		MatMenuModule,
		MenuModule,
		ThumbnailModule,
		ArchiveMenuModule,
		EllipsisWithCountModule,
		FormatDateModule,
		DetectTextTruncationDirective
	],
	declarations: [
		NgxArchiveCardComponent
	],
	exports: [
		NgxArchiveCardComponent
	]
})
export class NgxArchiveCardModule {}
